(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const roots = () => document.querySelectorAll('[data-editorial-cart]');

    const updateHeaderCount = (root) => {
      const count = Number(root.dataset.cartCount || 0);
      const link = document.querySelector('.editorial-header__cart');
      if (!link) return;
      let badge = link.querySelector('.editorial-header__cart-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'editorial-header__cart-count type-badge';
        link.append(badge);
      }
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      }
      link.setAttribute('aria-label', (root.dataset.headerCartLabel || '').replace('__COUNT__', String(count)));
    };

    const announce = (root, message, isError = false) => {
      const status = root.querySelector('[data-cart-status]');
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', isError);
      if (isError) status.setAttribute('role', 'alert');
      else status.setAttribute('role', 'status');
      if (isError) status.focus({ preventScroll: true });
    };

    const findFocusTarget = (root, focusId) => {
      if (!focusId) return null;
      return [...root.querySelectorAll('[data-focus-id]')].find((element) => element.dataset.focusId === focusId) || null;
    };

    const replaceSection = (root, html, focusId, message) => {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const fresh = documentFragment.querySelector(`#CartSection-${CSS.escape(root.dataset.sectionId)}`);
      if (!fresh) throw new Error('section');
      const scrollPosition = window.scrollY;
      root.replaceWith(fresh);
      init(fresh);
      updateHeaderCount(fresh);
      requestAnimationFrame(() => {
        window.scrollTo({ top: scrollPosition, behavior: 'auto' });
        const focusTarget = findFocusTarget(fresh, focusId) || fresh.querySelector('h1');
        if (focusTarget && focusId) focusTarget.focus({ preventScroll: true });
        if (message) announce(fresh, message);
      });
      return fresh;
    };

    const sectionHtmlFromResponse = async (root, payload) => {
      const sectionHtml = payload?.sections?.[root.dataset.sectionId];
      if (sectionHtml) return sectionHtml;
      const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(root.dataset.sectionId)}`, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('section');
      return response.text();
    };

    const mutate = async (root, url, body, options = {}) => {
      if (root.dataset.busy === 'true') return;
      root.dataset.busy = 'true';
      const busyElement = options.busyElement;
      if (busyElement) busyElement.setAttribute('aria-busy', 'true');
      if (options.trigger) options.trigger.disabled = true;
      announce(root, '');
      try {
        const payloadBody = { ...body, sections: [root.dataset.sectionId], sections_url: window.location.pathname };
        const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payloadBody) });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || payload.message || 'cart');
        const html = await sectionHtmlFromResponse(root, payload);
        replaceSection(root, html, options.focusId, options.message);
      } catch (error) {
        root.dataset.busy = 'false';
        if (busyElement) busyElement.removeAttribute('aria-busy');
        if (options.trigger) options.trigger.disabled = false;
        if (typeof options.onError === 'function') options.onError();
        announce(root, error.message && error.message !== 'cart' ? error.message : root.dataset.errorMessage, true);
      }
    };

    const init = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      root.dataset.busy = 'false';
      root.classList.add('is-enhanced');
      root.addEventListener('click', (event) => {
        const quantityButton = event.target.closest('[data-cart-quantity]');
        if (quantityButton) {
          const line = quantityButton.closest('[data-cart-line]');
          const input = line?.querySelector('[data-cart-quantity-input]');
          if (!line || !input) return;
          const direction = quantityButton.dataset.cartQuantity === 'plus' ? 1 : -1;
          const nextQuantity = Math.max(1, Math.min(99, Number(input.value || 1) + direction));
          if (nextQuantity === Number(input.value)) return;
          mutate(root, root.dataset.cartChangeUrl, { id: line.dataset.lineKey, quantity: nextQuantity }, { busyElement: line, trigger: quantityButton, focusId: quantityButton.dataset.focusId, message: root.dataset.updateMessage });
          return;
        }

        const removeLink = event.target.closest('[data-cart-remove]');
        if (removeLink) {
          event.preventDefault();
          const line = removeLink.closest('[data-cart-line]');
          if (!line) return;
          mutate(root, root.dataset.cartChangeUrl, { id: line.dataset.lineKey, quantity: 0 }, { busyElement: line, focusId: removeLink.dataset.focusId, message: root.dataset.removeMessage });
        }
      });

      root.addEventListener('change', (event) => {
        const quantityInput = event.target.closest('[data-cart-quantity-input]');
        if (quantityInput) {
          const line = quantityInput.closest('[data-cart-line]');
          if (!line) return;
          const quantity = Math.max(1, Math.min(99, Number(quantityInput.value || 1)));
          quantityInput.value = String(quantity);
          mutate(root, root.dataset.cartChangeUrl, { id: line.dataset.lineKey, quantity }, { busyElement: line, trigger: quantityInput, focusId: quantityInput.dataset.focusId, message: root.dataset.updateMessage, onError: () => { quantityInput.value = quantityInput.dataset.currentQuantity; } });
          return;
        }
        const giftToggle = event.target.closest('[data-cart-gift-toggle]');
        if (giftToggle) {
          const gift = giftToggle.closest('[data-cart-gift]');
          const note = gift?.querySelector('[data-cart-gift-note]');
          giftToggle.setAttribute('aria-expanded', String(giftToggle.checked));
          if (!giftToggle.checked && note) note.value = '';
          mutate(root, root.dataset.cartUpdateUrl, {
            attributes: { Geschenkbestellung: giftToggle.checked ? 'Ja' : '' },
            note: giftToggle.checked ? note?.value || '' : ''
          }, { trigger: giftToggle, focusId: 'cart-gift-toggle', message: root.dataset.giftMessage });
          return;
        }
        const giftNote = event.target.closest('[data-cart-gift-note]');
        if (giftNote) {
          const giftToggle = giftNote.closest('[data-cart-gift]')?.querySelector('[data-cart-gift-toggle]');
          if (!giftToggle?.checked) return;
          mutate(root, root.dataset.cartUpdateUrl, {
            attributes: { Geschenkbestellung: 'Ja' },
            note: giftNote.value
          }, { trigger: giftNote, focusId: 'cart-gift-note', message: root.dataset.giftMessage });
        }
      });

      root.addEventListener('submit', (event) => {
        const upsellForm = event.target.closest('.cart-upsell-card__form');
        if (upsellForm) {
          event.preventDefault();
          const card = upsellForm.closest('.cart-upsell-card');
          const submitter = event.submitter || upsellForm.querySelector('[type="submit"]');
          const id = Number(new FormData(upsellForm).get('id'));
          mutate(root, root.dataset.cartAddUrl, { items: [{ id, quantity: 1 }] }, { busyElement: card, trigger: submitter, focusId: 'cart-heading', message: root.dataset.addedMessage });
          return;
        }

        const cartForm = event.target.closest('[data-cart-form]');
        if (!cartForm || event.submitter?.name === 'checkout') return;
        event.preventDefault();
        const updates = {};
        cartForm.querySelectorAll('[data-cart-line]').forEach((line) => {
          const input = line.querySelector('[data-cart-quantity-input]');
          if (input) updates[line.dataset.lineKey] = Math.max(1, Math.min(99, Number(input.value || 1)));
        });
        const giftToggle = cartForm.querySelector('[data-cart-gift-toggle]');
        const giftNote = cartForm.querySelector('[data-cart-gift-note]');
        const body = { updates };
        if (giftToggle) {
          body.attributes = { Geschenkbestellung: giftToggle.checked ? 'Ja' : '' };
          body.note = giftToggle.checked ? giftNote?.value || '' : '';
        }
        mutate(root, root.dataset.cartUpdateUrl, body, { trigger: event.submitter, message: root.dataset.updateMessage });
      });

      updateHeaderCount(root);
    };

    roots().forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-editorial-cart]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    if (window.italianCollectionDrawerReady) {
      document.documentElement.classList.add('italian-collection-drawer-ready');
      document.documentElement.classList.add('italian-collection-sort-ready');
      return;
    }

    window.italianCollectionDrawerReady = true;
    document.documentElement.classList.add('italian-collection-drawer-ready');
    document.documentElement.classList.add('italian-collection-sort-ready');

    const updateDrawerState = () => {
      document.documentElement.classList.toggle(
        'italian-collection-drawer-is-open',
        Boolean(document.querySelector('[data-collection-drawer][open]'))
      );
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-collection-drawer-open]');

      if (openButton) {
        const drawer = document.getElementById(openButton.getAttribute('aria-controls'));

        if (!drawer) {
          return;
        }

        if (typeof drawer.showModal === 'function') {
          if (!drawer.open) {
            drawer.showModal();
          }
        } else {
          drawer.setAttribute('open', '');
        }

        updateDrawerState();

        window.requestAnimationFrame(() => {
          const focusTarget = drawer.querySelector('select, summary, input, button, a[href]');

          if (focusTarget) {
            focusTarget.focus({ preventScroll: true });
          }
        });

        return;
      }

      const closeButton = event.target.closest('[data-collection-drawer-close]');

      if (closeButton) {
        const drawer = closeButton.closest('[data-collection-drawer]');

        if (!drawer) {
          return;
        }

        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.removeAttribute('open');
        }

        updateDrawerState();
        return;
      }

      const drawer = event.target.closest('[data-collection-drawer]');

      if (drawer && event.target === drawer) {
        drawer.close();
      }
    });

    document.addEventListener('change', (event) => {
      const sortSelect = event.target.closest('[data-collection-sort-select]');

      if (!sortSelect) {
        return;
      }

      const form = sortSelect.form;

      if (!form) {
        return;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    document.addEventListener(
      'close',
      (event) => {
        if (event.target.matches('[data-collection-drawer]')) {
          updateDrawerState();
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["italian-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__italianCartDrawer) return;
    window.__italianCartDrawer = true;

    let opener = null;
    const pendingDrawerCloses = new WeakMap();
    const pendingMutations = new WeakMap();
    const savedGifts = new WeakMap();
    const drawer = () => document.querySelector('[data-cart-drawer]');
    const findFocusTarget = (root, focusId) => focusId ? [...root.querySelectorAll('[data-focus-id]')].find((node) => node.dataset.focusId === focusId) : null;
    const announce = (root, message, error = false) => {
      const status = root?.querySelector('[data-cart-drawer-status]');
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', error);
      status.setAttribute('role', error ? 'alert' : 'status');
      if (error) status.focus({ preventScroll: true });
    };
    const updateHeaderCount = (root) => {
      const link = document.querySelector('.editorial-header__cart');
      if (!link || !root) return;
      const count = Number(root.dataset.cartCount || 0);
      let badge = link.querySelector('.editorial-header__cart-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'editorial-header__cart-count type-badge';
        link.append(badge);
      }
      if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
      link.setAttribute('aria-label', (root.dataset.headerCartLabel || '').replace('__COUNT__', String(count)));
    };
    const initRoot = (root) => {
      if (!root) return;
      root.classList.add('is-enhanced');
      if (!savedGifts.has(root)) savedGifts.set(root, {
        checked: root.querySelector('[data-cart-drawer-gift-toggle]')?.checked || false,
        note: root.querySelector('[data-cart-drawer-gift-note]')?.value || ''
      });
      updateHeaderCount(root);
    };
    const open = (root = drawer(), source = null) => {
      if (!root || typeof root.showModal !== 'function') return false;
      if (source) opener = source;
      const cancelClose = pendingDrawerCloses.get(root);
      if (cancelClose) cancelClose();
      if (!root.open) root.showModal();
      document.documentElement.classList.add('cart-drawer-open');
      requestAnimationFrame(() => root.querySelector('[data-cart-drawer-close]')?.focus({ preventScroll: true }));
      return true;
    };
    const close = (root = drawer()) => {
      if (!root?.open || root.dataset.closing === 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.close();
        return;
      }
      root.dataset.closing = 'true';
      let timeoutId;
      const cleanup = () => {
        root.removeEventListener('transitionend', finishOnTransition);
        window.clearTimeout(timeoutId);
        pendingDrawerCloses.delete(root);
      };
      const finish = () => {
        cleanup();
        root.removeAttribute('data-closing');
        if (root.open) root.close();
      };
      const finishOnTransition = (event) => {
        if (event.target === root && event.propertyName === 'transform') finish();
      };
      pendingDrawerCloses.set(root, () => {
        cleanup();
        root.removeAttribute('data-closing');
      });
      root.addEventListener('transitionend', finishOnTransition);
      timeoutId = window.setTimeout(finish, 400);
    };
    const htmlFromPayload = async (root, payload) => {
      const bundled = payload?.sections?.[root.dataset.sectionId];
      if (bundled) return bundled;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', root.dataset.sectionId);
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('section');
      return response.text();
    };
    const syncList = (current, fresh, key) => {
      const existing = new Map([...current.children].map((node) => [key(node), node]));
      [...fresh.children].forEach((node, index) => {
        const previous = existing.get(key(node));
        const next = previous?.isEqualNode(node) ? previous : node;
        if (current.children[index] !== next) current.insertBefore(next, current.children[index] || null);
        if (previous && previous !== next) previous.remove();
        existing.delete(key(node));
      });
      existing.forEach((node) => node.remove());
    };
    const renderRoot = (root, html, options = {}) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      if (!fresh) throw new Error('section');
      const active = document.activeElement;
      const focusWasInside = root.contains(active);
      const focusId = active?.dataset.focusId || options.focusId;
      const scroll = root.querySelector('[data-cart-drawer-scroll]');
      const scrollTop = scroll.scrollTop;
      const rail = root.querySelector('.cart-drawer__upsell-rail');
      const scrollLeft = rail?.scrollLeft || 0;
      const sync = (selector, parent, before = null) => {
        const current = root.querySelector(selector);
        const next = fresh.querySelector(selector);
        if (current && next) {
          if (!current.isEqualNode(next)) current.replaceWith(next);
        } else if (current) current.remove();
        else if (next) parent.insertBefore(next, before);
      };
      sync('.cart-drawer__count');
      sync('.cart-drawer__shipping');
      const items = root.querySelector('.cart-drawer__items');
      const nextItems = fresh.querySelector('.cart-drawer__items');
      if (items && nextItems) syncList(items, nextItems, (node) => node.dataset.lineKey);
      else {
        sync('[data-cart-drawer-form]', scroll, scroll.firstChild);
        sync('[data-cart-drawer-empty]', scroll, scroll.firstChild);
      }
      const nextRail = fresh.querySelector('.cart-drawer__upsell-rail');
      if (rail && nextRail) syncList(rail, nextRail, (node) => node.querySelector('form')?.getAttribute('id'));
      else sync('.cart-drawer__upsells', scroll);
      const summary = root.querySelector('.cart-drawer__summary');
      const nextSummary = fresh.querySelector('.cart-drawer__summary');
      if (summary && nextSummary) {
        sync('.cart-drawer__discounts', summary, summary.querySelector('.cart-drawer__subtotal'));
        sync('.cart-drawer__subtotal');
        if (!options.preserveGift) {
          const toggle = root.querySelector('[data-cart-drawer-gift-toggle]');
          const nextToggle = fresh.querySelector('[data-cart-drawer-gift-toggle]');
          const note = root.querySelector('[data-cart-drawer-gift-note]');
          if (toggle && nextToggle) {
            toggle.checked = nextToggle.checked;
            toggle.setAttribute('aria-expanded', String(toggle.checked));
            if (note) note.value = fresh.querySelector('[data-cart-drawer-gift-note]')?.value || '';
            savedGifts.set(root, { checked: toggle.checked, note: note?.value || '' });
          }
        }
      } else sync('.cart-drawer__summary', root.querySelector('.cart-drawer__panel'));
      root.dataset.cartCount = fresh.dataset.cartCount;
      initRoot(root);
      if (options.open && !root.open && root.dataset.closing !== 'true') open(root);
      if (root.open) {
        scroll.scrollTop = scrollTop;
        if (rail?.isConnected) rail.scrollLeft = scrollLeft;
        requestAnimationFrame(() => {
          if (!root.open) return;
          if (focusWasInside && !active.isConnected) {
            const target = findFocusTarget(root, focusId) || root.querySelector('[data-cart-drawer-empty]') || root.querySelector('.cart-drawer__upsell-rail button:not(:disabled)') || root.querySelector('[data-cart-drawer-close]');
            target?.focus({ preventScroll: true });
          }
          if (options.message) announce(root, options.message);
        });
      }
      return root;
    };
    const refresh = async (options = {}) => {
      const root = drawer();
      if (!root) return null;
      await pendingMutations.get(root);
      const html = await htmlFromPayload(root, null);
      return renderRoot(root, html, { preserveGift: root.open, ...options });
    };
    const enqueueMutation = (root, operation) => {
      const pending = (pendingMutations.get(root) || Promise.resolve()).then(operation);
      pendingMutations.set(root, pending.catch(() => {}));
      return pending;
    };
    const mutate = async (root, url, body, options = {}) => {
      if (!root || (options.render !== false && root.dataset.busy === 'true')) return;
      return enqueueMutation(root, async () => {
        if (options.render !== false) root.dataset.busy = 'true';
        options.busyElement?.setAttribute('aria-busy', 'true');
        if (options.trigger) options.trigger.disabled = true;
        announce(root, '');
        try {
          const payloadBody = options.render === false ? body : { ...body, sections: [root.dataset.sectionId], sections_url: `${window.location.pathname}${window.location.search}` };
          const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payloadBody) });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.description || payload.message || 'cart');
          let fresh = root;
          if (options.render === false) announce(root, options.message);
          else {
            const html = await htmlFromPayload(root, payload);
            fresh = renderRoot(root, html, { ...options, preserveGift: true });
          }
          options.onSuccess?.();
          document.dispatchEvent(new CustomEvent('italian:cart:rendered', { detail: { count: Number(fresh.dataset.cartCount || 0) } }));
        } catch (error) {
          if (typeof options.onError === 'function') options.onError();
          announce(root, error.message && error.message !== 'cart' ? error.message : root.dataset.errorMessage, true);
        } finally {
          if (options.render !== false) root.dataset.busy = 'false';
          options.busyElement?.removeAttribute('aria-busy');
          if (options.trigger) options.trigger.disabled = false;
        }
      });
    };
    const addForm = async (form, trigger) => {
      const root = drawer();
      if (!root || root.dataset.busy === 'true') return;
      const fromDrawer = root.contains(form);
      return enqueueMutation(root, async () => {
        root.dataset.busy = 'true';
        form.setAttribute('aria-busy', 'true');
        if (trigger) trigger.disabled = true;
        try {
          const formData = new FormData(form);
          formData.set('sections', root.dataset.sectionId);
          formData.set('sections_url', `${window.location.pathname}${window.location.search}`);
          const response = await fetch(root.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.description || payload.message || 'cart');
          const html = await htmlFromPayload(root, payload);
          form.removeAttribute('aria-busy');
          if (trigger) trigger.disabled = false;
          const fresh = renderRoot(root, html, { open: !fromDrawer, preserveGift: true, message: root.dataset.addedMessage });
          document.dispatchEvent(new CustomEvent('italian:cart:rendered', { detail: { count: Number(fresh.dataset.cartCount || 0) } }));
        } catch (error) {
          if (!fromDrawer) open(root, trigger);
          announce(root, error.message && error.message !== 'cart' ? error.message : root.dataset.errorMessage, true);
        } finally {
          root.dataset.busy = 'false';
          form.removeAttribute('aria-busy');
          if (trigger) trigger.disabled = false;
        }
      });
    };
    const saveGift = (root, toggle, note, restoreOnError = false) => {
      const state = { checked: toggle.checked, note: toggle.checked ? note?.value || '' : '' };
      mutate(root, root.dataset.cartUpdateUrl, {
        attributes: { Geschenkbestellung: state.checked ? 'Ja' : '' },
        note: state.note
      }, {
        render: false,
        message: root.dataset.giftMessage,
        onSuccess: () => savedGifts.set(root, state),
        onError: () => {
          if (!restoreOnError || toggle.checked !== state.checked || (note?.value || '') !== state.note) return;
          const saved = savedGifts.get(root);
          toggle.checked = saved.checked;
          toggle.setAttribute('aria-expanded', String(saved.checked));
          if (note) note.value = saved.note;
        }
      });
    };

    document.addEventListener('keydown', (event) => {
      const root = drawer();
      if (event.key !== 'Escape' || !root?.open) return;
      event.preventDefault();
      close(root);
    });
    document.addEventListener('click', (event) => {
      const root = drawer();
      const cartTrigger = event.target.closest('[data-cart-drawer-trigger]');
      if (cartTrigger && root) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = cartTrigger;
        refresh({ open: true }).catch(() => { window.location.href = cartTrigger.href; });
        return;
      }
      if (!root) return;
      if (event.target.closest('[data-cart-drawer-close]')) { close(root); return; }
      if (event.target === root) { close(root); return; }
      const quantityButton = event.target.closest('[data-cart-drawer-quantity]');
      if (quantityButton) {
        const line = quantityButton.closest('[data-cart-drawer-line]');
        const input = line?.querySelector('[data-cart-drawer-quantity-input]');
        if (!line || !input) return;
        const direction = quantityButton.dataset.cartDrawerQuantity === 'plus' ? 1 : -1;
        const quantity = Math.max(1, Math.min(99, Number(input.value || 1) + direction));
        if (quantity === Number(input.value)) return;
        mutate(root, root.dataset.cartChangeUrl, { id: line.dataset.lineKey, quantity }, { busyElement: line, trigger: quantityButton, focusId: quantityButton.dataset.focusId, message: root.dataset.updatedMessage });
        return;
      }
      const remove = event.target.closest('[data-cart-drawer-remove]');
      if (remove) {
        event.preventDefault();
        const line = remove.closest('[data-cart-drawer-line]');
        if (line) mutate(root, root.dataset.cartChangeUrl, { id: line.dataset.lineKey, quantity: 0 }, { busyElement: line, focusId: remove.dataset.focusId, message: root.dataset.removedMessage });
      }
    });
    document.addEventListener('change', (event) => {
      const giftToggle = event.target.closest('[data-cart-drawer-gift-toggle]');
      if (giftToggle) {
        const root = giftToggle.closest('[data-cart-drawer]');
        const gift = giftToggle.closest('[data-cart-drawer-gift]');
        const note = gift?.querySelector('[data-cart-drawer-gift-note]');
        if (!root) return;
        giftToggle.setAttribute('aria-expanded', String(giftToggle.checked));
        if (!giftToggle.checked && note) note.value = '';
        saveGift(root, giftToggle, note, true);
        return;
      }
      const giftNote = event.target.closest('[data-cart-drawer-gift-note]');
      if (giftNote) {
        const root = giftNote.closest('[data-cart-drawer]');
        const gift = giftNote.closest('[data-cart-drawer-gift]');
        const giftToggle = gift?.querySelector('[data-cart-drawer-gift-toggle]');
        if (!root || !giftToggle?.checked) return;
        saveGift(root, giftToggle, giftNote);
        return;
      }
      const input = event.target.closest('[data-cart-drawer-quantity-input]');
      const root = input?.closest('[data-cart-drawer]');
      const line = input?.closest('[data-cart-drawer-line]');
      if (!root || !line) return;
      const quantity = Math.max(1, Math.min(99, Number(input.value || 1)));
      input.value = String(quantity);
      mutate(root, root.dataset.cartChangeUrl, { id: line.dataset.lineKey, quantity }, { busyElement: line, trigger: input, focusId: input.dataset.focusId, message: root.dataset.updatedMessage, onError: () => { input.value = input.dataset.currentQuantity; } });
    });
    document.addEventListener('submit', (event) => {
      const root = drawer();
      const quickForm = event.target.closest('[data-cart-drawer-quick-add]');
      if (quickForm && root) {
        event.preventDefault();
        addForm(quickForm, event.submitter || quickForm.querySelector('[type="submit"]'));
        return;
      }
      const upsellForm = event.target.closest('[data-cart-drawer] .cart-upsell-card__form');
      if (upsellForm && root) {
        event.preventDefault();
        addForm(upsellForm, event.submitter || upsellForm.querySelector('[type="submit"]'));
        return;
      }
    });
    document.addEventListener('italian:cart:updated', (event) => {
      refresh({ open: event.detail?.open !== false, message: event.detail?.message || drawer()?.dataset.addedMessage }).catch(() => {});
    });
    document.addEventListener('shopify:section:load', (event) => initRoot(event.target.querySelector('[data-cart-drawer]')));
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.querySelector('[data-cart-drawer]')?.open) opener?.focus({ preventScroll: true });
    });
    document.addEventListener('close', (event) => {
      if (!event.target.matches?.('[data-cart-drawer]')) return;
      document.documentElement.classList.remove('cart-drawer-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    }, true);
    initRoot(drawer());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["italian-product-highlights"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-highlights')) {
    customElements.define('product-highlights', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.features = [...this.querySelectorAll('[data-highlight-slot]')];
        this.images = [...this.querySelectorAll('[data-highlight-image]')];
        this.lastOpened = null;
        this.dataset.enhanced = 'true';
        this.features.forEach((feature) => {
          const close = feature.querySelector('.product-highlights__close');
          if (close) {
            close.hidden = false;
            close.addEventListener('click', () => {
              const summary = feature.querySelector('summary');
              feature.open = false;
              summary.focus({ preventScroll: true });
              const rect = summary.getBoundingClientRect();
              if (rect.top < 0 || rect.bottom > window.innerHeight) summary.scrollIntoView({ block: 'center', behavior: 'instant' });
            }, { signal });
          }
          feature.addEventListener('toggle', () => {
            if (feature.open) this.lastOpened = feature;
            this.updateImage();
          }, { signal });
        });
        this.updateImage();
      }
      updateImage() {
        const selected = this.lastOpened?.open ? this.lastOpened : this.features.find((feature) => feature.open);
        const slot = selected?.dataset.highlightSlot;
        const image = slot ? this.images.find((candidate) => candidate.dataset.highlightImage === slot) : this.images[0];
        this.images.forEach((candidate) => { candidate.hidden = candidate !== image; });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        delete this.dataset.enhanced;
        this.querySelectorAll('.product-highlights__close').forEach((button) => { button.hidden = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["italian-product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const messageWith = (template, replacements) => Object.entries(replacements).reduce((message, [token, value]) => message.replaceAll(token, value), template || '');
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  const updateHeaderCart = async (section) => {
    try {
      const response = await fetch(section.dataset.cartUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const link = document.querySelector('.editorial-header__cart');
      if (!link) return;
      let count = link.querySelector('.editorial-header__cart-count');
      if (!count && cart.item_count > 0) { count = document.createElement('span'); count.className = 'editorial-header__cart-count type-badge'; link.append(count); }
      if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
      link.setAttribute('aria-label', messageWith(section.dataset.cartCountMessage, { __count__: String(cart.item_count) }));
    } catch {}
  };
  const initControls = (section) => {
    const cards = [...section.querySelectorAll('.pairing-card')].map((card) => ({
      card,
      select: card.querySelector('[data-pairing-select]'),
      label: card.querySelector('[data-pairing-select-label]'),
      available: !card.querySelector('[data-pairing-select]').disabled,
    }));
    const total = section.querySelector('[data-pairing-total]');
    const count = section.querySelector('[data-pairing-count]');
    const summary = section.querySelector('[data-pairing-summary]');
    const hint = section.querySelector('[data-pairing-hint]');
    const button = section.querySelector('[data-pairing-add]');
    const message = section.querySelector('[data-pairing-message]');
    if (!cards.length || !total || !button || !message || button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';
    let busy = false;
    const selectedCards = () => cards.filter(({ available, select }) => available && select.getAttribute('aria-pressed') === 'true');
    const update = () => {
      const selected = selectedCards();
      total.textContent = formatMoney(selected.reduce((sum, { select }) => sum + Number(select.dataset.price), 0));
      count.textContent = selected.length === 1 ? section.dataset.countOneLabel : messageWith(section.dataset.countOtherLabel, { __count__: String(selected.length) });
      summary.hidden = selected.length === 0;
      hint.hidden = selected.length > 0;
      button.disabled = busy || selected.length === 0;
      button.setAttribute('aria-busy', String(busy));
      cards.forEach(({ select, available }) => {
        select.disabled = busy || !available;
      });
    };
    const setSelected = (entry, selected) => {
      if (busy || !entry.available) return;
      entry.select.setAttribute('aria-pressed', String(selected));
      entry.card.classList.toggle('is-selected', selected);
      entry.label.textContent = selected ? section.dataset.selectedLabel : section.dataset.selectLabel;
      message.textContent = '';
      message.classList.remove('is-error');
      update();
    };
    cards.forEach((entry) => {
      entry.select.hidden = false;
      entry.select.addEventListener('click', () => setSelected(entry, entry.select.getAttribute('aria-pressed') !== 'true'));
    });
    section.querySelector('[data-pairing-bundle]').hidden = false;
    update();
    button.addEventListener('click', async () => {
      if (busy) return;
      const selected = selectedCards();
      if (!selected.length) { message.textContent = section.dataset.selectionRequiredLabel; return; }
      busy = true;
      const label = button.textContent;
      button.textContent = section.dataset.addingLabel;
      message.textContent = '';
      message.classList.remove('is-error');
      update();
      try {
        const response = await fetch(section.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: selected.map(({ select }) => ({ id: Number(select.dataset.variantId), quantity: 1 })) }),
        });
        if (!response.ok) throw new Error('add');
        message.textContent = messageWith(section.dataset.addedMessage, { __count__: String(selected.length) });
        await updateHeaderCart(section);
        document.dispatchEvent(new CustomEvent('italian:cart:updated', { detail: { open: true } }));
      } catch {
        message.textContent = section.dataset.addErrorLabel;
        message.classList.add('is-error');
      } finally {
        busy = false;
        button.textContent = label;
        update();
      }
    });
  };
  const wireRetry = (section) => {
    const retry = section.querySelector('[data-pairing-retry]');
    if (!retry || retry.dataset.initialized === 'true') return;
    retry.dataset.initialized = 'true';
    retry.addEventListener('click', () => loadRecommendations(section));
  };
  const loadRecommendations = async (section) => {
    const current = section.querySelector('[data-pairing-content]');
    const statusMessage = current?.querySelector('[data-pairing-status-message]');
    const retry = current?.querySelector('[data-pairing-retry]');
    if (!current) return;
    current.setAttribute('aria-busy', 'true');
    if (statusMessage) statusMessage.textContent = section.dataset.loadingLabel;
    if (retry) retry.hidden = true;
    try {
      const response = await fetch(section.dataset.recommendationsUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('recommendations');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(`#${section.id} [data-pairing-content]`);
      if (!fresh) throw new Error('recommendations');
      // Keep the current cards if the visitor has already started choosing.
      // A late recommendation response must not discard their selection or cart request.
      if (!current.isConnected || current.querySelector('[data-pairing-select][aria-pressed="true"], [data-pairing-add][aria-busy="true"]')) {
        current.removeAttribute('aria-busy');
        return;
      }
      fresh.removeAttribute('aria-busy');
      current.replaceWith(fresh);
      initControls(section);
      wireRetry(section);
    } catch {
      current.removeAttribute('aria-busy');
      const failedMessage = current.querySelector('[data-pairing-status-message]');
      const failedRetry = current.querySelector('[data-pairing-retry]');
      if (failedMessage) failedMessage.textContent = section.dataset.errorLabel;
      if (failedRetry) failedRetry.hidden = false;
      wireRetry(section);
    }
  };
  const init = (section) => {
    if (section.dataset.initialized === 'true') return; section.dataset.initialized = 'true'; initControls(section); wireRetry(section);
    if (section.dataset.mode === 'manual' || !section.dataset.recommendationsUrl) return;
    loadRecommendations(section);
  };
  document.querySelectorAll('[data-product-pairing]').forEach(init); document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-product-pairing]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["italian-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.ItalianProductShowcaseControlsReady) {
      return;
    }

    window.ItalianProductShowcaseControlsReady = true;

    const selector = '[data-product-showcase]';
    const railSelector = '[data-product-showcase-rail]';
    const controlsSelector = '[data-product-showcase-controls]';
    const previousSelector = '[data-product-showcase-prev]';
    const nextSelector = '[data-product-showcase-next]';
    const readyAttribute = 'productShowcaseReady';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const getScrollStep = (rail) => {
      const card = rail.querySelector('.italian-product-showcase__product');

      if (!card) {
        return rail.clientWidth;
      }

      const railStyles = window.getComputedStyle(rail);
      const columnGap = parseFloat(railStyles.columnGap || railStyles.gap || '0') || 0;

      return card.getBoundingClientRect().width + columnGap;
    };

    const updateControls = (section) => {
      const rail = section.querySelector(railSelector);
      const controls = section.querySelector(controlsSelector);
      const previousButton = section.querySelector(previousSelector);
      const nextButton = section.querySelector(nextSelector);

      if (!rail || !controls || !previousButton || !nextButton) {
        return;
      }

      const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
      controls.hidden = !hasOverflow;

      if (!hasOverflow) {
        previousButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      const maxScroll = rail.scrollWidth - rail.clientWidth - 2;
      previousButton.disabled = rail.scrollLeft <= 2;
      nextButton.disabled = rail.scrollLeft >= maxScroll;
    };

    const initShowcase = (section) => {
      if (section.dataset[readyAttribute] === 'true') {
        updateControls(section);
        return;
      }

      const rail = section.querySelector(railSelector);
      const previousButton = section.querySelector(previousSelector);
      const nextButton = section.querySelector(nextSelector);

      if (!rail || !previousButton || !nextButton) {
        return;
      }

      section.dataset[readyAttribute] = 'true';

      previousButton.addEventListener('click', () => {
        rail.scrollBy({
          left: getScrollStep(rail) * -1,
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      });

      nextButton.addEventListener('click', () => {
        rail.scrollBy({
          left: getScrollStep(rail),
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      });

      rail.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(() => updateControls(section));
        },
        { passive: true }
      );

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => updateControls(section));
        resizeObserver.observe(rail);
      } else {
        window.addEventListener('resize', () => updateControls(section));
      }

      updateControls(section);
    };

    const init = (root = document) => {
      root.querySelectorAll(selector).forEach(initShowcase);
    };

    init();
    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  const messageWith = (template, replacements) => Object.entries(replacements).reduce((message, [token, value]) => message.replaceAll(token, value), template || '');
  const updateCartCount = async (root) => {
    try {
      const response = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const link = document.querySelector('.editorial-header__cart');
      if (!link) return;
      let count = link.querySelector('.editorial-header__cart-count');
      if (!count && cart.item_count > 0) { count = document.createElement('span'); count.className = 'editorial-header__cart-count type-badge'; link.append(count); }
      if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
      link.setAttribute('aria-label', messageWith(root.dataset.cartCountMessage, { __count__: String(cart.item_count) }));
    } catch {
      // The add-to-cart request already succeeded; a stale header count must not turn it into an error.
    }
  };
  const init = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-product-form]');
    const buybox = root.querySelector('[data-product-buybox]');
    const sticky = root.querySelector('[data-product-sticky]');
    const stickyButton = root.querySelector('[data-sticky-submit]');
    const stickyMessage = root.querySelector('[data-sticky-message]');
    const variantSelect = root.querySelector('[data-product-variant]');
    const optionPicker = root.querySelector('[data-product-options]');
    const optionInputs = [...root.querySelectorAll('[data-option-input]')];
    const quantity = root.querySelector('[data-product-quantity]');
    const submit = root.querySelector('[data-product-submit]');
    const submitLabel = root.querySelector('[data-submit-label]');
    const message = root.querySelector('[data-product-message]');
    const price = root.querySelector('[data-product-price]');
    const discount = root.querySelector('[data-product-discount]');
    const comparePriceRow = root.querySelector('[data-product-compare-row]');
    const comparePrice = root.querySelector('[data-product-compare-price]');
    const unitPrice = root.querySelector('[data-product-unit-price]');
    const availability = root.querySelector('[data-product-availability]');
    const header = document.querySelector('[data-editorial-header]');
    const galleryItems = [...root.querySelectorAll('[data-gallery-item]')];
    const galleryViewport = root.querySelector('[data-product-gallery-viewport]');
    const galleryPrevious = root.querySelector('[data-gallery-previous]');
    const galleryNext = root.querySelector('[data-gallery-next]');
    const galleryStatus = root.querySelector('[data-gallery-status]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileGallery = window.matchMedia('(max-width: 749px)');
    const primaryGalleryImage = root.querySelector('[data-gallery-primary] .editorial-product__gallery-image');
    const primaryImageSizes = primaryGalleryImage?.getAttribute('sizes') || '';
    const galleryMedia = new Map(galleryItems.map((item, tileIndex) => {
      const image = item.querySelector('.editorial-product__gallery-image');
      return [String(item.dataset.mediaId || ''), {
        tileIndex,
        src: image?.getAttribute('src') || '',
        srcset: image?.getAttribute('srcset') || '',
        alt: image?.getAttribute('alt') || ''
      }];
    }));
    const originalPrimaryMedia = galleryMedia.get(String(galleryItems[0]?.dataset.mediaId || ''));
    const controlsController = new AbortController();
    root.editorialProductControlsController = controlsController;
    const quantityButtons = [...root.querySelectorAll('[data-quantity-step]')];
    const syncQuantityButtons = () => quantityButtons.forEach((button) => {
      button.disabled = Number(button.dataset.quantityStep) < 0 ? Number(quantity.value) <= Number(quantity.min) : Number(quantity.value) >= Number(quantity.max);
    });
    quantityButtons.forEach((button) => {
      button.hidden = false;
      button.addEventListener('click', () => {
        if (!quantity.validity.valid) quantity.value = quantity.min;
        if (Number(button.dataset.quantityStep) < 0) quantity.stepDown(); else quantity.stepUp();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: controlsController.signal });
    });
    quantity?.addEventListener('change', syncQuantityButtons, { signal: controlsController.signal });
    quantity?.addEventListener('input', syncQuantityButtons, { signal: controlsController.signal });
    syncQuantityButtons();
    const variants = [...(variantSelect?.options || [])].map((option) => {
      let options = [];
      try { options = JSON.parse(option.dataset.options || '[]'); } catch { options = []; }
      return {
        id: option.value,
        options,
        available: option.dataset.available === 'true',
        price: option.dataset.price || '',
        discount: option.dataset.discount || '',
        comparePrice: option.dataset.comparePrice || '',
        unitPrice: option.dataset.unitPrice || '',
        featuredMediaId: option.dataset.featuredMediaId || ''
      };
    });
    let selectedVariant = variants.find((item) => item.id === variantSelect?.value) || variants[0] || null;
    const syncBuyboxStickyTop = () => {
      const headerHeight = header?.dataset.sticky === 'true' ? header.getBoundingClientRect().height : 0;
      root.style.setProperty('--ep-buybox-sticky-top', `${Math.round(headerHeight + 16)}px`);
    };
    syncBuyboxStickyTop();
    if (header && 'ResizeObserver' in window) {
      root.editorialProductHeaderObserver?.disconnect();
      root.editorialProductHeaderObserver = new ResizeObserver(syncBuyboxStickyTop);
      root.editorialProductHeaderObserver.observe(header);
    }
    let galleryFrame = 0;
    const currentGalleryIndex = () => {
      if (!galleryViewport || !galleryItems.length) return 0;
      const viewportRect = galleryViewport.getBoundingClientRect();
      const isRtl = getComputedStyle(galleryViewport).direction === 'rtl';
      const viewportStart = isRtl ? viewportRect.right : viewportRect.left;
      return galleryItems.reduce((closest, item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemStart = isRtl ? itemRect.right : itemRect.left;
        const distance = Math.abs(itemStart - viewportStart);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
    };
    const updateGalleryControls = () => {
      galleryFrame = 0;
      const index = currentGalleryIndex();
      galleryItems.forEach((item, position) => {
        const isActive = !mobileGallery.matches || position === index;
        item.inert = !isActive;
        if (!isActive) {
          item.querySelector('video')?.pause();
          const frame = item.querySelector('iframe');
          if (frame && item.dataset.wasActive === 'true') frame.src = frame.src;
        }
        item.dataset.wasActive = String(isActive);
      });
      if (!galleryPrevious || !galleryNext || !galleryStatus || !galleryItems.length) return;
      galleryPrevious.disabled = index === 0;
      galleryNext.disabled = index === galleryItems.length - 1;
      const nextStatus = messageWith(root.dataset.galleryPositionMessage, {
        __index__: String(index + 1),
        __total__: String(galleryItems.length)
      });
      if (galleryStatus.textContent.trim() !== nextStatus) galleryStatus.textContent = nextStatus;
    };
    const queueGalleryControls = () => {
      cancelAnimationFrame(galleryFrame);
      galleryFrame = requestAnimationFrame(updateGalleryControls);
    };
    const scrollGalleryTo = (index) => {
      if (!mobileGallery.matches || !galleryViewport || !galleryItems[index]) return;
      const viewportRect = galleryViewport.getBoundingClientRect();
      const itemRect = galleryItems[index].getBoundingClientRect();
      const rtl = getComputedStyle(galleryViewport).direction === 'rtl';
      galleryViewport.scrollBy({ left: rtl ? itemRect.right - viewportRect.right : itemRect.left - viewportRect.left, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
    };
    const moveGallery = (direction) => scrollGalleryTo(Math.max(0, Math.min(galleryItems.length - 1, currentGalleryIndex() + direction)));
    const onGalleryPrevious = () => moveGallery(-1);
    const onGalleryNext = () => moveGallery(1);
    galleryViewport?.addEventListener('scroll', queueGalleryControls, { passive: true });
    galleryPrevious?.addEventListener('click', onGalleryPrevious);
    galleryNext?.addEventListener('click', onGalleryNext);
    const onGalleryLayoutChange = () => {
      if (mobileGallery.matches) setPrimaryGalleryImage(originalPrimaryMedia);
      syncGalleryToVariant(selectedVariant);
      queueGalleryControls();
    };
    mobileGallery.addEventListener('change', onGalleryLayoutChange);
    const galleryResizeObserver = galleryViewport && 'ResizeObserver' in window ? new ResizeObserver(queueGalleryControls) : null;
    galleryResizeObserver?.observe(galleryViewport);
    root.editorialProductGalleryViewport = galleryViewport;
    root.editorialProductGalleryScroll = queueGalleryControls;
    root.editorialProductGalleryPrevious = galleryPrevious;
    root.editorialProductGalleryPreviousClick = onGalleryPrevious;
    root.editorialProductGalleryNext = galleryNext;
    root.editorialProductGalleryNextClick = onGalleryNext;
    root.editorialProductGalleryMediaQuery = mobileGallery;
    root.editorialProductGalleryMediaChange = onGalleryLayoutChange;
    root.editorialProductGalleryResizeObserver = galleryResizeObserver;
    root.editorialProductGalleryFrame = () => galleryFrame;
    queueGalleryControls();
    const setPrimaryGalleryImage = (descriptor) => {
      if (!primaryGalleryImage || !descriptor?.src) return;
      primaryGalleryImage.src = descriptor.src;
      if (descriptor.srcset) primaryGalleryImage.srcset = descriptor.srcset;
      else primaryGalleryImage.removeAttribute('srcset');
      if (primaryImageSizes) primaryGalleryImage.sizes = primaryImageSizes;
      primaryGalleryImage.alt = descriptor.alt;
    };
    const syncGalleryToVariant = (variantData) => {
      const descriptor = galleryMedia.get(String(variantData?.featuredMediaId || ''));
      if (mobileGallery.matches) {
        if (descriptor) scrollGalleryTo(descriptor.tileIndex);
        return;
      }
      setPrimaryGalleryImage(descriptor || originalPrimaryMedia);
    };

    const syncOptionControls = (variantData) => {
      if (!variantData || !optionInputs.length) return;
      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        input.checked = variantData.options[position] === input.value;
      });
      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const isAvailable = variants.some((candidate) => candidate.available && candidate.options[position] === input.value);
        input.disabled = !isAvailable;
        const state = input.parentElement?.querySelector('[data-option-state]');
        if (state) state.textContent = isAvailable ? '' : root.dataset.soldOutLabel;
      });
    };

    const applyVariant = (variantData, { updateUrl = true, updateGallery = true } = {}) => {
      if (!variantData) return;
      selectedVariant = variantData;
      if (variantSelect) variantSelect.value = variantData.id;
      if (price) price.textContent = variantData.price;
      if (discount) {
        discount.textContent = variantData.discount ? `-${variantData.discount}%` : '';
        discount.hidden = !variantData.discount;
      }
      if (comparePrice) {
        comparePrice.textContent = variantData.comparePrice;
      }
      if (comparePriceRow) comparePriceRow.hidden = !variantData.comparePrice;
      if (unitPrice) {
        unitPrice.textContent = variantData.unitPrice;
        unitPrice.hidden = !variantData.unitPrice;
      }
      if (availability) {
        availability.textContent = variantData.available ? root.dataset.availableLabel : root.dataset.soldOutLabel;
        availability.dataset.available = String(variantData.available);
      }
      if (submit) submit.disabled = !variantData.available;
      if (submitLabel) submitLabel.textContent = variantData.available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      if (stickyButton) {
        stickyButton.disabled = !variantData.available;
        stickyButton.textContent = variantData.available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      }
      const stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = variantData.price;
      const stickyTitle = root.querySelector('[data-sticky-title]');
      if (stickyTitle) {
        const productTitle = root.querySelector('.editorial-product__title')?.textContent.trim() || '';
        stickyTitle.textContent = variantData.options.length ? `${productTitle} · ${variantData.options.join(' · ')}` : productTitle;
      }
      syncOptionControls(variantData);
      if (updateGallery) syncGalleryToVariant(variantData);
      if (updateUrl && window.history?.replaceState) {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variantData.id);
        window.history.replaceState({}, '', nextUrl);
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', () => {
      if (!input.checked) return;
      const position = Number(input.dataset.optionPosition) - 1;
      const selectedValues = [...root.querySelectorAll('[data-option-group]')].map((group) => group.querySelector('[data-option-input]:checked')?.value || '');
      let nextVariant = variants.find((candidate) => candidate.available && candidate.options.every((value, index) => value === selectedValues[index]));
      let adjusted = false;
      if (!nextVariant) {
        nextVariant = variants.find((candidate) => candidate.available && candidate.options[position] === input.value);
        adjusted = Boolean(nextVariant);
      }
      if (!nextVariant || !variantSelect) {
        syncOptionControls(selectedVariant);
        if (message) message.textContent = root.dataset.variantUnavailableMessage;
        return;
      }
      variantSelect.value = nextVariant.id;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      if (adjusted && message) message.textContent = root.dataset.variantAdjustedMessage;
    }));

    if (optionPicker && variants.length && selectedVariant) {
      applyVariant(selectedVariant, { updateUrl: false });
      optionPicker.hidden = false;
      root.classList.add('is-variant-picker-ready');
    }

    const add = async (source) => {
      const sourceButton = source === 'sticky' ? stickyButton : submit;
      const sourceLabel = source === 'sticky' ? stickyButton : submitLabel;
      const sourceMessage = source === 'sticky' ? stickyMessage : message;
      const value = Number(quantity?.value || 1);
      message.textContent = ''; if (stickyMessage) stickyMessage.textContent = '';
      if (!Number.isInteger(value) || value < 1 || value > 99) { sourceMessage.textContent = root.dataset.quantityInvalidMessage; quantity?.focus(); return; }
      sourceButton.disabled = true; const original = sourceLabel.textContent; sourceLabel.textContent = root.dataset.addingLabel;
      try {
        const response = await fetch(root.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantSelect.value), quantity: value }] }) });
        if (!response.ok) throw new Error('add');
        sourceMessage.textContent = messageWith(root.dataset.addedMessage, { __quantity__: String(value), __title__: root.querySelector('.editorial-product__title').textContent.trim() });
        sourceLabel.textContent = root.dataset.addedLabel; await updateCartCount(root);
        document.dispatchEvent(new CustomEvent('italian:cart:updated', { detail: { open: true } }));
        setTimeout(() => { sourceLabel.textContent = selectedVariant?.available === false ? root.dataset.soldOutLabel : original; }, 1800);
      } catch { sourceMessage.textContent = root.dataset.addErrorMessage; sourceLabel.textContent = original; }
      finally { sourceButton.disabled = selectedVariant?.available === false; }
    };
    form?.addEventListener('submit', (event) => { event.preventDefault(); add('main'); });
    stickyButton?.addEventListener('click', () => add('sticky'));
    variantSelect?.addEventListener('change', () => {
      const nextVariant = variants.find((item) => item.id === variantSelect.value);
      if (!nextVariant) return;
      if (message) message.textContent = '';
      applyVariant(nextVariant);
    });
    if (sticky && buybox && 'IntersectionObserver' in window) {
      const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
      const competingRegion = document.querySelector('[data-product-pairing]');
      let buyboxHasPassed = false;
      let competingRegionVisible = false;
      let externalControlFocused = false;
      const syncSticky = () => {
        const visible = mobileBreakpoint.matches && buyboxHasPassed && !competingRegionVisible && !externalControlFocused;
        sticky.hidden = !visible;
        sticky.classList.toggle('is-visible', visible);
        document.documentElement.classList.toggle('editorial-product-sticky-visible', document.querySelector('.editorial-product__sticky.is-visible') !== null);
      };
      const observer = new IntersectionObserver(([entry]) => {
        buyboxHasPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        syncSticky();
      }, { threshold: .08 });
      const onViewportChange = () => syncSticky();
      observer.observe(buybox);
      const competingObserver = competingRegion ? new IntersectionObserver(([entry]) => {
        competingRegionVisible = entry.isIntersecting;
        syncSticky();
      }, { threshold: .08 }) : null;
      competingObserver?.observe(competingRegion);
      const onFocusIn = (event) => {
        externalControlFocused = event.target instanceof HTMLElement && !root.contains(event.target);
        syncSticky();
      };
      const onFocusOut = () => requestAnimationFrame(() => {
        externalControlFocused = document.activeElement instanceof HTMLElement && !root.contains(document.activeElement);
        syncSticky();
      });
      document.addEventListener('focusin', onFocusIn);
      document.addEventListener('focusout', onFocusOut);
      mobileBreakpoint.addEventListener('change', onViewportChange);
      root.editorialProductStickyObserver = observer;
      root.editorialProductCompetingObserver = competingObserver;
      root.editorialProductStickyMediaQuery = mobileBreakpoint;
      root.editorialProductStickyViewportChange = onViewportChange;
      root.editorialProductFocusIn = onFocusIn;
      root.editorialProductFocusOut = onFocusOut;
    }
  };
  document.querySelectorAll('[data-editorial-product]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-editorial-product]').forEach(init));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-editorial-product]').forEach((root) => {
    root.editorialProductHeaderObserver?.disconnect();
    root.editorialProductControlsController?.abort();
    root.editorialProductStickyObserver?.disconnect();
    root.editorialProductCompetingObserver?.disconnect();
    root.editorialProductStickyMediaQuery?.removeEventListener('change', root.editorialProductStickyViewportChange);
    document.removeEventListener('focusin', root.editorialProductFocusIn);
    document.removeEventListener('focusout', root.editorialProductFocusOut);
    root.editorialProductGalleryViewport?.removeEventListener('scroll', root.editorialProductGalleryScroll);
    root.editorialProductGalleryPrevious?.removeEventListener('click', root.editorialProductGalleryPreviousClick);
    root.editorialProductGalleryNext?.removeEventListener('click', root.editorialProductGalleryNextClick);
    root.editorialProductGalleryMediaQuery?.removeEventListener('change', root.editorialProductGalleryMediaChange);
    root.editorialProductGalleryResizeObserver?.disconnect();
    cancelAnimationFrame(root.editorialProductGalleryFrame?.() || 0);
    const sticky = root.querySelector('[data-product-sticky]');
    sticky?.classList.remove('is-visible');
    if (sticky) sticky.hidden = true;
    document.documentElement.classList.toggle('editorial-product-sticky-visible', document.querySelector('.editorial-product__sticky.is-visible') !== null);
  }));
})();

  } catch(e) { console.error(e); }
})();
})();
